import React from 'react';
import PageLoader from 'components/common/page_loader';
import { useTheme } from '@mui/material';

const GalleryViewLoader = () => {
  const theme = useTheme();

  return (
    <PageLoader
      indicatorSize={'small'}
      indicatorStyle={{
        color: 'white',
        backgroundColor: 'black',
        opacity: '0.75',
        padding: theme.spacing(2),
        borderRadius: '50%',
      }}
    />
  );
};

export default GalleryViewLoader;
